import UserRoles from "./enums/UserRole";

class User {
  constructor(
    public id: number,
    // public complete_name: string,
    public name: string,
    public surname: string,
    public username: string,
    public email: string,
    public id_country: number,
    public affiliation: string,
    public profession: string,
    public activity_start: number,
    public active: number,
    public password: string,
    public role: UserRoles,
    public board_member: boolean,
    public created_on?: Date
  ) {}

  // public is_admin(): boolean {
  //   return this.role === UserRoles.ADMIN;
  // }

    public static EmptyInstance(): User {
        return new User(
            -1, // id
            "", // name
            "", // surname
            "", // username
            "", // email
            -1, // id_country
            "", // affiliation
            "", // profession
            -1, // activity_start
            1, // active
            "", // password
            UserRoles.VISITOR, // role
            false,
            new Date() // created_on
        );
    }
}

class UserSummaryOutDTO{
  constructor(
    public id: number,
    public username: string
  ){}

  public static EmptyInstance(): UserSummaryOutDTO{
    return new UserSummaryOutDTO(-1, "");
  }
}

export { 
  User,
  UserSummaryOutDTO
};
